// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2PLVC","tab":"Tabs_tab__1F3fg","tabActive":"Tabs_tabActive__1XtYb"};